import projectConfig from '../../project.config.js'
import _ from 'lodash'
import def from './default.json'
import development from './development.json'
import dev01 from './dev01.json'
import stage from './stage.json'
import training from './training.json'
import production from './production.json'

let o = def;
switch (projectConfig.env) {
    case "dev01":
        _.merge(o, dev01);
        break;
    case "stage":
        _.merge(o, stage);
        break;
    case "training":
        _.merge(o, training);
        break;
    case "production":
        _.merge(o, production);
        break;
    case "development":
    default:
        _.merge(o, development);
        break;
}

export default o;


// WEBPACK FOOTER //
// ./src/config/config.js